import BN from "bn.js";
import { None, Option } from "space-monad";
import Web3 from "web3";
import { AllowedBlockchains } from "../../chain/models/internal";

export const chainsMap: Record<number, AllowedBlockchains> = {
  1: "ETH",
  137: "MATIC",
  3: "ROPSTEN",
  56: "BSC",
  80001: "MUMBAI",
};

export interface ChainSpec {
  chainId: string; // A 0x-prefixed hexadecimal string
  chainName: string;
  nativeCurrency: {
    name: string;
    symbol: string; // 2-6 characters long
    decimals: 18;
  };
  gasPrice: () => Promise<Option<string>>; // Gas price in Wei
  rpcUrls: string[];
  blockExplorerUrls?: string[];
}

export const chainSpecs: Record<keyof typeof chainsMap, ChainSpec> = {
  1: {
    chainId: "0x1",
    chainName: "Ethereum Mainnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    gasPrice: async () => None,
    rpcUrls: ["https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"],
    blockExplorerUrls: ["https://etherscan.io"],
  },
  3: {
    chainId: "0x3",
    chainName: "Ropsten Test Network",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    gasPrice: async () => None,
    rpcUrls: ["https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"],
    blockExplorerUrls: ["https://ropsten.etherscan.io"],
  },
  137: {
    chainId: "0x89",
    chainName: "Polygon Mainnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    gasPrice: async () => {
      const response = await fetch(
        "https://gasstation-mainnet.matic.network/v2"
      );

      return Option((await response.json()) as any)
        .map((x) => x.standard)
        .map((x) => x.maxFee)
        .map((x) => Web3.utils.toWei(new BN(x), "Gwei").toString());
    },
    rpcUrls: ["https://polygon-rpc.com/"],
    blockExplorerUrls: ["https://polygonscan.com/"],
  },
  56: {
    chainId: "0x38",
    chainName: "BSC Mainnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    gasPrice: async () => None,
    rpcUrls: ["https://bsc-dataseed1.binance.org/"],
    blockExplorerUrls: ["https://bscscan.com/"],
  },
  80001: {
    chainId: "0x13881",
    chainName: "Mumbai",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    gasPrice: async () => None,
    rpcUrls: ["https://rpc-mumbai.matic.today"],
    blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
  },
};
